import { PotentialTerminationReasonsResponseDTO } from '@/api/account-controller/DTOs';
import { PotentialTerminationReason } from '@/auth';

export const adaptPotentialTerminationReasonsResponseToPotentialTerminationReasons =
  (
    potentialTerminationReasons: PotentialTerminationReasonsResponseDTO,
  ): PotentialTerminationReason[] => {
    return potentialTerminationReasons.map(reason => ({
      id: reason.potentialTerminationReasonID,
      name: reason.name,
      description: reason.description,
    }));
  };
